export const maxPinnedUsers = 5;